import React, {useContext, useEffect} from "react";
import DetailsComponent from "./DetailsComponent";
import {CardCoach, CoachList, CardWhiteCoach, ActionBio, CardFull} from "./FacilitadorStyle";
import {TypeTitle} from "../../../styles/Products";
import Color from "../../../assets/Colors";
import {Content} from "../../../styles/GlobalStyles";
import {CoursesContext} from "../../../context/CoursesContext";
import {useParams} from "react-router-dom";
import {LoadComponet} from "../../../components/loaders/Loader";
import {isMobile} from "../../../constants/Helpers";

export default function FacilitadorSection({facilitadores}) {
   const {getFacilitators, facilitatorsCourse, getInfoFacilitators} = useContext(CoursesContext);
   let {id} = useParams();

   useEffect(() => {
      getFacilitators(id);
   }, [id]);

   if (facilitatorsCourse.isLoading) return <LoadComponet />;
   if (facilitatorsCourse.data.length === 0) return null;

   return (
      <DetailsComponent
         title="facilitador"
         iconClass="facilitador"
         titleClass="centerDesk"
         column={true}
         iconTitle={require(".././../../assets/icons/coach.png")}
      >
         <Content>
            <CoachList>
               {React.Children.toArray(
                  facilitatorsCourse.data.map((item) => {
                     if (item.type === "CMV") {
                        return (
                           <CardFull>
                              <CardCoach>
                                 <img
                                    src={`http://domecqapi.trebolbit.com/${isMobile ? item.pathImageWebMobile : item.pathImageWebDesktop}`}
                                    alt={item.facilitatorName}
                                    className="profileImg"
                                 />
                                 <CardWhiteCoach>
                                    <TypeTitle color={Color.primary}>{`${item.facilitatorName} ${item.facilitatorLastName}`}</TypeTitle>
                                 </CardWhiteCoach>
                              </CardCoach>
                           </CardFull>
                        );
                     }
                     return (
                        <CardCoach>
                           <img
                              src={`http://domecqapi.trebolbit.com/${isMobile ? item.pathImageWebMobile : item.pathImageWebDesktop}`}
                              alt={item.facilitatorName}
                              className="profileImg"
                           />
                           <CardWhiteCoach>
                              <img src={require("../../../assets/icons/class.png")} className="iconDot" alt="dot" />
                              <TypeTitle color={Color.primary} className="facilitadorName">
                                 {`${item.facilitatorName} ${item.facilitatorLastName}`}
                              </TypeTitle>
                              <ActionBio to={`/facilitador/${item.idFacilitator}`}>
                                 Ver bio
                                 <span>
                                    <img src={require("../../../assets/icons/to_right.png")} alt="next" className="mediaIcon" />
                                 </span>
                              </ActionBio>
                           </CardWhiteCoach>
                        </CardCoach>
                     );
                  }),
               )}
               {/* {facilitadores.map((item, index) => {})} */}
            </CoachList>
         </Content>
      </DetailsComponent>
   );
}
